import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/lib/i18n";
import { AuthProvider } from "@/contexts/AuthContext";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import Products from "@/pages/public/Products";
import ProductDetail from "@/pages/public/ProductDetail";
import Refurbished from "@/pages/public/Refurbished";
import Contact from "@/pages/public/Contact";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminCatalog from "@/pages/admin/AdminCatalog";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminBilling from "@/pages/admin/AdminBilling";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  useEffect(() => { document.title = "HiCare Lab Solutions — Precision Laboratory & Medical Equipment"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/refurbished" element={<Refurbished />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<AdminCatalog resource="products" />} />
            <Route path="refurbished" element={<AdminCatalog resource="refurbished" isRefurb />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="quotations" element={<AdminBilling resource="quotations" title="Quotations" />} />
            <Route path="invoices" element={<AdminBilling resource="invoices" title="Invoices" />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
